import styles from "../styles/_components/colorPicker.module.scss";

const PRESET_COLORS = [
  "#C8B6FF", "#D4A574", "#B8D4E3", "#A8C5E2", "#F2B5D4",
  "#F5C5A3", "#D4E4C1", "#FFD6A5", "#FF9AA2", "#B5EAD7",
  "#E2F0CB", "#FFDAC1", "#C7CEEA", "#FFC8DD", "#BDE0FE",
];

const ColorPicker = ({ value, onChange, label = "צבע השירות" }) => {
  return (
    <div className={styles.container}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.grid}>
        {PRESET_COLORS.map((color) => (
          <button
            key={color}
            type="button"
            className={`${styles.swatch} ${value === color ? styles.swatchActive : ""}`}
            style={{ backgroundColor: color }}
            onClick={() => onChange(color)}
            title={color}
          >
            {value === color && <span className={styles.check}>✓</span>}
          </button>
        ))}
        {/* No color option */}
        <button
          type="button"
          className={`${styles.swatch} ${styles.swatchNone} ${!value ? styles.swatchActive : ""}`}
          onClick={() => onChange("")}
          title="ללא צבע"
        >
          {!value && <span className={styles.check}>✓</span>}
        </button>
      </div>
    </div>
  );
};

export { PRESET_COLORS };
export default ColorPicker;
